/**
 * Dieses Modul sammelt alle Aktionen und Reducer-Events welche von der
 * IBE ausgeführt werden können und damit den State der Anwendung ändern.
 */

import moment from 'moment';
import param from 'jquery-param';

/*
 IBE
 */

export const START_RENDER = 'START_RENDER';
export const STOP_RENDER = 'STOP_RENDER';

export function startRender() { return { type: START_RENDER } };
export function stopRender() { return { type: STOP_RENDER } };

/*
 Calendar
*/
export const CLICK_DAY = 'CLICK_DAY';
export const HOVER_DAY = 'HOVER_DAY';
export const SET_PERIOD = 'SET_PERIOD';
export const THIS_MONTH = 'THIS_MONTH';
export const NEXT_MONTH = 'NEXT_MONTH';
export const PREV_MONTH = 'PREV_MONTH';
export const RESET_DATE = "RESET_DATE";
export const ABORT_SELECTION = "ABORT_SELECTION";
export const SET_SELECTION = "SET_SELECTION";

export function clickDay(date) { return { type: CLICK_DAY, date }; }
export function hoverDay(date) { return { type: HOVER_DAY, date }; }
export function setPeriod(params) { return { type: SET_PERIOD, ...params }; }
export function thisMonth() { return { type: THIS_MONTH }; }
export function nextMonth() { return { type: NEXT_MONTH }; }
export function prevMonth() { return { type: PREV_MONTH }; }
export function resetDate() { return { type: RESET_DATE }; }
export function abortSelection() { return { type: ABORT_SELECTION }; }
export function setSelection(start, end) { return { type: SET_SELECTION, start, end }; }

/*
 Main
 */

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_CURRENCY = 'SET_CURRENCY';

export function setLanguage(language) { return { type: SET_LANGUAGE, language } };
export function setCurrency(currency) { return { type: SET_CURRENCY, currency } };

/*
 PeopleSelect
*/

export const CHANGE_PEOPLE = 'CHANGE_PEOPLE';

export function changePeople(key, value) { return { type: CHANGE_PEOPLE, key, value } };


/*
 App
 */
export const TOGGLE_PANEL = "TOGGLE_PANEL";
export const ADD_ROOM = "ADD_ROOM";

export function togglePanel(panel) { return { type: TOGGLE_PANEL, panel } };
export function addRoom() { return { type: ADD_ROOM } };


export const RECEIVED_SEARCH_RESULTS = "RECEIVED_SEARCH_RESULTS";
export const RECEIVED_INITIAL_OFFERS = "RECEIVED_INITIAL_OFFERS";

export function receivedSearchResults(results) { return {type: RECEIVED_SEARCH_RESULTS, results} };
export function receivedInitialOffers(results) { return {type: RECEIVED_INITIAL_OFFERS, results} };


export function executeSearch() {
    return (dispatch, getState) => {
        dispatch({type: 'LOADING_RESULTS'});
        let state = getState();

        let params = {
            from: moment(state.calendar.selectionStart).format("YYYY-MM-DD"),
            to: moment(state.calendar.selectionEnd).format("YYYY-MM-DD"),
            ...state.people,
            cache: 0,
        };

        let proxy = 'http://localhost:3002/proxy/?' + param({ url: 'http://www.explorer-hotels.com/api/engine/?' + param(params) });

        fetch(proxy).then(r => r.json()).then((r) => {
            dispatch({type: 'RECEIVED_SEARCH_RESULTS', results: r.results});
        }).catch(e => console.exception(e));
    }
}


export function loadInitialOffers() {
    return (dispatch, getState) => {

        let params = {
            cache: 0,
            client: 106,
        };

        let params2 = param({ url: 'http://www.oberstdorf.de/api/engine/?' + param(params) });
        let proxy = `http://localhost:3002/proxy/?${params2}`;

        fetch(proxy).then(r => r.json()).then(
            r => dispatch(receivedInitialOffers(r.results)),
            e => console.exception(e)
        );
    }
}



/** WEBPACK FOOTER **
 ** ../ibe/actions.js
 **/